module.exports = __WEBPACK_EXTERNAL_MODULE_37__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/operator/filter"
// module id = 37
// module chunks = 0